import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k9kr3fm5vd2o">
      <Routes data-id="element-1" data-mp="3ka49exfq43h8">
        <Route path="/" element={<Home data-id="element-3" data-mp="3k8t9x9tb9hvx" />} data-id="element-2" data-mp="3k8jiriwj54on" />
        <Route path="/privacy" element={<Privacy data-id="element-5" data-mp="3f9yi5idd8izo" />} data-id="element-4" data-mp="3k78fdk6zxyy2" />
      </Routes>
    </BrowserRouter>;
}